import { faClock } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Pill } from '@/components/ui/pill/pill.component';

export function AppointmentDateToBeDefinedPill() {
  return (
    <Pill
      variant="warning"
      icon={faClock}
      label="Data a definir"
      className="font-normal"
      data-testid={DataTestIdEnum.APPOINTMENT_CARD_DATE_TO_BE_DEFINED_PILL}
    />
  );
}
